import { render, staticRenderFns } from "./resumeDetail.vue?vue&type=template&id=36037544&scoped=true"
import script from "./resumeDetail.vue?vue&type=script&lang=js"
export * from "./resumeDetail.vue?vue&type=script&lang=js"
import style0 from "./resumeDetail.vue?vue&type=style&index=0&id=36037544&prod&lang=scss&scoped=true"
import style1 from "./resumeDetail.vue?vue&type=style&index=1&id=36037544&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36037544",
  null
  
)

export default component.exports